import axios from "axios";
import { IPageResponse } from "common/interfaces/IPageResponse";
import { CustomerEnergyAgreement, CustomerEnergyAgreementData } from "components/EnergyAgreements/model";
import { convertToPageable, downloadFile, extractData, handleApiException, handleReportResponse, handleResponse } from "helpers/apiResponseHelper";
import { apiService } from "services/api.service";

async function getAllEnergyAgreements(pageRequest: any) : Promise<IPageResponse<CustomerEnergyAgreement>>{
  return axios.get(apiService.getApiUrl() + '/energy/agreements/admin', {
    params: pageRequest
  }).then(handleResponse).then(convertToPageable);
}

async function getCustomersEnergyAgreementsData(customerId: number) : Promise<CustomerEnergyAgreementData>{
  return axios.get(apiService.getApiUrl() + `/energy/agreements/admin/${customerId}`).then(handleResponse).then(extractData).catch(handleApiException);;
}

async function getEnergyAgreementsReport() {
    return axios.get(apiService.getApiUrl() + '/energy/agreements/admin/report', {
        responseType: 'blob'
    }).then(handleReportResponse).then((res) => downloadFile(res.fileName, res.data));
}

const EnergyAgreementService = {
  getAllEnergyAgreements,
  getCustomersEnergyAgreementsData,
  getEnergyAgreementsReport
}

export default EnergyAgreementService;
